
import { GameCommunicationBaseSender } from '@pp/core/src/controllers/gameCommunication/senders/GameCommunicationBaseSender';
import type { GameCommunicationSenderType } from '@pp/core/src/controllers/gameCommunication/types';

import { Bets } from '../../../config/bets';
import type { GameStore } from '../../../store/GameStore';

interface CashoutSenderProps {
  betCode: Bets;
}
export class GameCommunicationCashOutSender extends GameCommunicationBaseSender {
  name = 'cashout';
  send(_: CashoutSenderProps, store: GameStore, sender: GameCommunicationSenderType): void {
    const state = store.getState();
    const gameChannel = state.gameState.gameChannel;
    const gameId = state.gameState.gameId;
    const userId = state.config.playerConfig?.userId;
    const { highflyerState } = state;

    if (gameChannel && userId) {
      let message = '';
      message += `<command channel="${gameChannel}">`;
      message += `<cashout gId="${gameId}" rc="${highflyerState.multiplier}" hc="0" bc="${_.betCode}" ck="${Date.now()}"/>`;
      message += '</command>';

      sender?.(message);
    }
  }
}
